<script lang="ts">
  import ProductFilters from './ProductFilters.svelte'
  import { currentProducts } from '../../store/products'
</script>

<section class="products px-8 mt-16">
  <ProductFilters />
  <div class="product-list grid sm:grid-cols-[repeat(2,1fr)] md:grid-cols-[repeat(4,1fr)]	gap-10 mt-8">
    {#each $currentProducts as {name, img}}
      <div class="flex flex-wrap content-start">
        
        <img src="assets/products/{img}" alt="" class="w-full">
        <p class="uppercase">
          {name}
        </p>
    </div>
  {/each}
  </div>
</section>